<template>
    <div id="scanner_settings">
        <div v-if="is_initialized">
            <carousel
                v-if="is_mobile_width"
                ref="settings_carousel"
                :perPage="1"
                :speed="390"
                :minSwipeDistance="120"
                :paginationEnabled="false"
                :navigateTo="current_column_index"
                >
                <slide
                    v-for="(menu, index) in menus"
                    :key="menu.component_name"
                    >
                    <NavigationLeft v-if="index != 0"></NavigationLeft>
                    <component
                        :is="menu.component_name"
                        :is_inverted="is_inverted">
                    </component>
                    <NavigationRight v-if="index+1 != menus.length"></NavigationRight>
                </slide>
            </carousel>

            <div v-else>
                <div class="ui top tabular menu">
                    <div v-for="menu in menus"
                        class="item pointer"
                        :class="{'active': current_setting_component == menu.component_name}"
                        :style="{color: theme.color.font}"
                        @click="current_setting_component = menu.component_name">
                        {{ menu.title }}
                    </div>
                </div>

                <component
                    :is="current_setting_component"
                    :is_inverted="is_inverted">
                </component>
            </div>
        </div>
    </div>
</template>

<script>
import AllDetails from './settings/details.vue'
import Groups from './settings/groups.vue'
import Operations from './settings/operations.vue'

import NavigationLeft from './navigation/left.vue'
import NavigationRight from './navigation/right.vue'

import { Carousel, Slide } from 'vue-carousel'

import WebCamera from 'webcamjs'

export default {
    components: {
        AllDetails,
        Groups,
        Carousel,

        NavigationRight,
        NavigationLeft,

        Slide,
        Operations,
    },
    props: {
        is_processing: {
            default: false,
            type: Boolean
        },
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            is_mobile_width: false,
            current_column_index: 0,
            current_setting_component: 'Groups',
            menus: []
        }
    },
    computed: {
        language() {
            return this.$store.state.language
        },
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        settings() {
            return this.current_store.settings
        },
    },
    watch: {
        'language': {
            handler(value) {
                try {
                    this.init()
                } catch (e) {
                    console.log(e)
                    this.$noty.error(e)
                }
            },
            deep: true,
        },
        'settings.is_scan_action_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '點貨作業模式'
                    this.$tc('ui.scanner.settings.is_scan_action_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '檢視資料模式'
                    this.$tc('ui.scanner.settings.is_scan_action_mode.false')
                )
            }
            localStorage.setItem('scanner_is_scan_action_mode', value)
        },
        'settings.is_distributed_to_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '分撥模式'
                    this.$tc('ui.scanner.settings.is_distributed_to_mode.true')
                )
            } else {
                this.$noty.warning(
                    // 取消分撥
                    this.$tc('ui.scanner.settings.is_distributed_to_mode.false')
                )
            }
            localStorage.setItem('scanner_is_distributed_to_mode', value)
        },
        'settings.is_package_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '自動包裝'
                    this.$tc('ui.scanner.settings.is_package_mode.true')
                )
                this.settings.is_unpackage_mode = false
            } else {
                this.$noty.warning(
                    // '取消自動包裝'
                    this.$tc('ui.scanner.settings.is_package_mode.false')
                )
            }
            localStorage.setItem('scanner_is_package_mode', value)
        },
        'settings.is_unpackage_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '自動拆包'
                    this.$tc('ui.scanner.settings.is_unpackage_mode.true')
                )
                this.settings.is_package_mode = false
            } else {
                this.$noty.warning(
                    // '取消自動拆包'
                    this.$tc('ui.scanner.settings.is_unpackage_mode.false')
                )
            }
            localStorage.setItem('scanner_is_unpackage_mode', value)
        },
        'settings.is_operation_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '選用訂單'
                    this.$tc('ui.scanner.settings.is_operation_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '取消選訂單'
                    this.$tc('ui.scanner.settings.is_operation_mode.false')
                )
            }
            localStorage.setItem('scanner_is_operation_mode', value)
            this.set_menus()
        },
        // 'settings.imitate_mode'(value) {
        //
        //     if (value) {
        //         this.settings.is_update_core_waybill_mode = false
        //         this.settings.core_waybill_template_mode = 'card'
        //         this.$noty.warning(
        // '必填資料快速套用, 限定卡片模式'
        //     this.$tc('ui.scanner.settings.is_scan_action_mode.false')
        // )
        //     } else {
        //         this.$noty.information(
        // '關閉快速套用')
        // this.$tc('ui.scanner.settings.is_scan_action_mode.true')
        //
        //     }
        //     localStorage.setItem('scanner_imitate_mode', value)
        // },
        'settings.is_auto_print_label_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '自動產標'
                    this.$tc('ui.scanner.settings.is_auto_print_label_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '不產標籤'
                    this.$tc('ui.scanner.settings.is_auto_print_label_mode.false')
                )
            }
            localStorage.setItem('scanner_is_auto_print_label_mode', value)
        },
        'settings.is_print_small_label_of_any_number_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '任意小標'
                    this.$tc('ui.scanner.settings.is_print_small_label_of_any_number_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '不產小標'
                    this.$tc('ui.scanner.settings.is_print_small_label_of_any_number_mode.false')
                )
            }
            localStorage.setItem('scanner_is_print_small_label_of_any_number_mode', value)
        },
        'settings.is_reload_core_waybill_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '自動產標'
                    this.$tc('ui.scanner.settings.is_reload_core_waybill_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '不產標籤'
                    this.$tc('ui.scanner.settings.is_reload_core_waybill_mode.false')
                )
            }
            localStorage.setItem('scanner_is_reload_core_waybill_mode', value)
        },
        'settings.is_webcam_mode'(value) {
            localStorage.setItem('scanner_is_webcam_mode', value)
            if (value) {
                WebCamera.on("error", err => {
                    this.$noty.warning(
                        this.$t("ui.scanner.errors.web_camera_error_will_close")
                    )
                    setTimeout((() => {
                        this.settings.is_webcam_mode = false
                    }), 500)
                    this.$store.commit('provider/scanner_module/clear_webcam_snap_interval')
                    WebCamera.reset()
                })
                WebCamera.set({
                    width: 192,
                    height: 108,
                    dest_width: 1920,
                    dest_height: 1080
                })
                WebCamera.set("constraints", {
                    optional: [{ minWidth: 600 }]
                })
                WebCamera.attach("#webcam")
                this.$store.commit(
                    'provider/scanner_module/set_webcam_snap_interval', 
                    setInterval(() => {
                        for (let pending_webcam_snap of _.filter(this.current_store.webcam_snaps, (webcam_snap) => {
                            return webcam_snap.status == "Pending" || webcam_snap.status == "Error"
                        })) {
                            this.$store.dispatch('provider/scanner_module/upload_webcam_snap', pending_webcam_snap);
                        }
                    }, 10000)
                );
            } else {
                console.log("WebCamera off")
                this.$store.commit('provider/scanner_module/clear_webcam_snap_interval')
                WebCamera.reset()
            }
        },
        'settings.is_core_waybill_creation_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '建立運單'
                    this.$tc('ui.scanner.settings.is_core_waybill_creation_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '不建立運單'
                    this.$tc('ui.scanner.settings.is_core_waybill_creation_mode.false')
                )
            }
            localStorage.setItem('scanner_is_core_waybill_creation_mode', value)
        },
        'settings.is_high_performance_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '高效能模式'
                    this.$tc('ui.scanner.settings.is_high_performance_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '一般模式'
                    this.$tc('ui.scanner.settings.is_high_performance_mode.false')
                )
            }
            localStorage.setItem('scanner_is_high_performance_mode', value)
        },
        'settings.is_scan_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '掃瞄模式'
                    this.$tc('ui.scanner.settings.is_scan_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '手動模式'
                    this.$tc('ui.scanner.settings.is_scan_mode.false')
                )
            }
            localStorage.setItem('scanner_is_scan_mode', value)
        },
        'settings.is_update_core_waybill_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '更新運單'
                    this.$tc('ui.scanner.settings.is_update_core_waybill_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '檢視運單'
                    this.$tc('ui.scanner.settings.is_update_core_waybill_mode.false')
                )
            }
            localStorage.setItem('scanner_is_update_core_waybill_mode', value)
        },
        'settings.is_noty_audio_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '提示聲模式'
                    this.$tc('ui.scanner.settings.is_noty_audio_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '靜音模式'
                    this.$tc('ui.scanner.settings.is_noty_audio_mode.false')
                )
            }
            localStorage.setItem('scanner_is_noty_audio_mode', value)
        },
        'settings.is_speech_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '語音報件模式'
                    this.$tc('ui.scanner.settings.is_speech_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '靜音語音報件模式'
                    this.$tc('ui.scanner.settings.is_speech_mode.false')
                )
            }
            localStorage.setItem('scanner_is_speech_mode', value)
        },
        'settings.is_quick_corewaybill_related_columns_mode'(value) {
            if (value) {
                this.$noty.information(
                    // '啟用 快速套用欄位'
                    this.$tc('ui.scanner.settings.is_quick_corewaybill_related_columns_mode.true')
                )
            } else {
                this.$noty.warning(
                    // '關閉 快速套用欄位'
                    this.$tc('ui.scanner.settings.is_quick_corewaybill_related_columns_mode.false')
                )
            }
            localStorage.setItem('scanner_is_quick_corewaybill_related_columns_mode', value)
        },
        'settings.is_batch_mode'(value) {
            if (value) {
                this.$noty.warning(
                    // '警告！已啟用 批量作業模式，號碼需用逗號區隔，將不再提醒必填資訊', 2000
                    this.$tc('ui.scanner.settings.is_batch_mode.true', 3)
                , 2000)
            } else {
                this.$noty.information(
                    // '關閉 批量作業模式'
                    this.$tc('ui.scanner.settings.is_batch_mode.false')
                )
            }
            localStorage.setItem('scanner_is_batch_mode', value)
        },
        'settings.core_waybill_template_mode'(value) {
            var content = ""
            // 極簡檢視模式
            content = (value == 'min_card')
                ? this.$tc('ui.scanner.settings.core_waybill_template_mode.min_card')
                : content

            // 卡片檢視模式
            content = (value == 'card')
                ? this.$tc('ui.scanner.settings.core_waybill_template_mode.card')
                : content

            // 詳細檢視模式
            content = (value == 'detail')
                ? this.$tc('ui.scanner.settings.core_waybill_template_mode.detail')
                : content

            this.$noty.information(content)
            // localStorage.setItem('scanner_core_waybill_template_mode', value)
        },
        is_mobile_width(value) {
            setTimeout(() => {
                if (value && this.is_initialized) {
                    this.current_column_index = 1
                }
            }, 100)
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.menus = []
                    this.is_initialized = false
                    resolve()
                })
                await this.set_menus()
                await this.set_is_mobile_width()
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        set_menus() {
            this.menus = [
                {
                    // "title": "掃描設定",
                    "title": this.$t('ui.scanner.menus.settings'),
                    "component_name": "AllDetails",
                },
                {
                    // "title": "設定包",
                    "title": this.$t('ui.scanner.menus.setting_group'),
                    "component_name": "Groups",
                },
            ]
            if (this.settings.is_operation_mode) {
                this.menus.push({
                    // "title": "訂單管理",
                    "title": this.$t('ui.scanner.menus.operation'),
                    "component_name": "Operations",
                })
            }
            return Promise.resolve()
        },
        set_is_mobile_width() {
            this.is_mobile_width = (this.style.width <= 767)
                ? true
                : false

            $(window).resize(() => {
                this.is_mobile_width = (this.style.width <= 767)
                    ? true
                    : false
            })
            return Promise.resolve()
        },
    },

}
</script>

<style lang="scss" scoped>
    #scanner_settings {
        .ui.top.menu .item {
            color: white;
        }
        .ui.top.menu .item.active {
            border-color: white;
            background: inherit;
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
        }
    }
    .VueCarousel-slide {
        position: relative;
    }

</style>
